import { baseAPI } from "./baseApi";

/**
 * An API client for interacting with user settings endpoints.
 */
export const UserSettingsApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getUserSettings: builder.query({
      query: (userID) => ({
        url: "/api/userSettings/" + userID,
      }),
      providesTags: ["UserSettings"],
    }),
    saveUserSettings: builder.mutation({
      query: (payload) => ({
        url: "/api/userSettings/saveSettings",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["UserSettings"],
    }),
  }),
});

export const {
  useGetUserSettingsQuery,
  useSaveUserSettingsMutation,
} = UserSettingsApi;
